import $ from 'jquery';
window.$ = window.jQuery = $;

export default function initFilterableBlocks() {
	$('.filterable').on( 'click change', '.filterable__trigger', null, function(){
		// Prep args
		var filterable = $(this).parents('.filterable');
		var args = filterable.data('filterable-args');
		args.filter_mode = 'custom';

		filterable.find('.filterable__user-filter').each(function(){
			args.filters[$(this).attr('name')] = $(this).val();
		});

		filterable.addClass('filterable__loading');

		// Fetch new block contents
		$.ajax(WPAPI+'ct4/v1/blocks/render', {
			method: 'GET',
			data: {
				layout: filterable.data('filterable-layout'),
				args: args,
			},
			success: function(data, textStatus, jqXHR){
				var newBlock = $(data.html);

				filterable.find('.filterable__replace').first().replaceWith(
					newBlock.find('.filterable__replace').first()
				);
				filterable.removeClass('filterable__loading');
			}
		});
	});
}
